<template>
  <div class="app-wrapper">
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <navbar />
      <app-main />
    </div>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'
import Navbar from './components/Navbar.vue'
import AppMain from './components/AppMain.vue'

export default {
  name: 'Layout',
  components: {
    Sidebar,
    Navbar,
    AppMain
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.app-wrapper {
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  font-family: $font-family;
  background-color: $page-bg;
}

.sidebar-container {
  width: $sidebar-width;
  flex-shrink: 0;
  background-color: $sidebar-bg;
  overflow-y: auto;
  overflow-x: hidden;
  transition: $transition-base;

  // Slim, unobtrusive scrollbar that matches the dark sidebar
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.08);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
}

.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  background-color: $page-bg;
}
</style>
